import { EventEmitter } from '@angular/core';
var PdfExportService = /** @class */ (function () {
    function PdfExportService() {
        this.isExportingPdf = false;
        this.readyReportCounter = 0;
        this.imageLoadedCounter = {};
        this.listReadyReports = [];
        this.triggerIncrementReportReady = new EventEmitter();
        this.imagedLoadedTrigger = new EventEmitter();
    }
    PdfExportService.prototype.updateExportingPdf = function (isExportingPdf) {
        this.isExportingPdf = isExportingPdf;
    };
    PdfExportService.prototype.resetImageCounter = function () {
        this.imageLoadedCounter = {};
    };
    PdfExportService.prototype.resetListReadyReport = function () {
        this.listReadyReports = [];
        this.readyReportCounter = 0;
    };
    Object.defineProperty(PdfExportService.prototype, "exportingPdf", {
        get: function () {
            return this.isExportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    PdfExportService.prototype.incrementNumberReportReady = function (component) {
        // prevent duplicate component ready
        if (this.listReadyReports.indexOf(component) < 0) {
            this.readyReportCounter++;
            this.triggerIncrementReportReady.emit(this.readyReportCounter);
            this.listReadyReports.push(component);
        }
    };
    PdfExportService.prototype.updateNumberImageLoaded = function (component) {
        var currentCounter = this.imageLoadedCounter[component];
        if (!currentCounter) {
            // inital counter value
            currentCounter = 1;
        }
        else {
            currentCounter += 1;
        }
        this.imageLoadedCounter[component] = currentCounter;
        this.imagedLoadedTrigger.emit({
            component: component,
            currentCounter: currentCounter
        });
    };
    Object.defineProperty(PdfExportService.prototype, "numberReportReady", {
        get: function () {
            return this.readyReportCounter;
        },
        enumerable: true,
        configurable: true
    });
    return PdfExportService;
}());
export { PdfExportService };



// WEBPACK FOOTER //
// ./src/app/services/export-pdf/pdf-export.service.ts.pre-build-optimizer.js